module.exports = __webpack_public_path__ + "img/icon-warning-wind-red.6ff90b1b.svg";